import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Container,
  Dialog,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import styles from "./clientsAmountBalanceDialogStyles";
import ClientsConfirmationBalanceDialog from "../ClientConfirmationBalanceDialog";

ClientsAmountBalanceDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function ClientsAmountBalanceDialog({ onClose, open, action, idUser, user, fetchClientBalance }) {
  const [balances, setBalances] = useState(0);
  const [commentary, setCommentary] = useState("");

  const handleCreditsChange = (event) => {
    setBalances(event.target.value);
  };
  
  const handleCommentaryChange = (event) => {
    setCommentary(event.target.value);
  };

  const [openDialog, setOpenDialog] = useState(null);

  const handleDialogOpen = (dialogName, action) => {
    setOpenDialog(dialogName);
  };

  const handleLocalDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setBalances(0);
    setCommentary('');
    setOpenDialog(null);
    onClose();
  };
  
  const handleContinueClick = (event, reason) => {
    if (balances === null || balances === '' || balances === 0) {
      return;
    }
    handleDialogOpen("CreditsConfirmationDialog");
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          {action} saldo
        </Typography>
        <Typography component="div" variant="body1" >
          Ingresa la cantidad de saldo
        </Typography>
        
        { action === 'Remover' && <Typography component="div" variant="body1">
          El saldo máximo para remover es <strong>{user?.actual_balance}</strong>
        </Typography>}
        
        <Container style={styles.subtitle}></Container>

        <TextField
          id="standard-basic"
          label="Número de saldo"
          variant="standard"
          onChange={handleCreditsChange}
          type="number"
          InputProps={{
            inputProps: { min: 0 },
            startAdornment: (
              <InputAdornment position="start">$</InputAdornment>
            ),
          }}
          sx={styles.textField}
        />

        <Container sx={styles.divider}></Container>
        
        <TextField
          id="standard-basic"
          label="Comentario"
          variant="standard"
          onChange={handleCommentaryChange}
          type="text"
          multiline
          inputProps={{ maxLength: 50 }}
          sx={styles.textField}
        />

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleLocalDialogClose}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleContinueClick();
            }}
            disabled={
              balances === "" ||
              balances === "0" ||
              balances <= 0 ||
              balances.toString().includes('.') ||
              !(/^\d*$/.test(balances)) ||
              ( action === 'Reducción' && parseInt(balances) > user?.actual_balance)
              /* parseInt(balances) > user?.actual_balance */
            }
            sx={balances !== '' || balances !== '0' ? styles.activeButton : styles.inactiveButton}
          >
            Continuar
          </Button>
        </Container>
      </Container>

      <ClientsConfirmationBalanceDialog
        open={openDialog === "CreditsConfirmationDialog"}
        action={action}
        name={user?.fullname}
        idUser={idUser}
        commentary={commentary}
        fetchClientBalance={fetchClientBalance}
        onClose={handleDialogClose}
        balances={balances}
        setCommentary={setCommentary}
        setBalances={setBalances}
      />
    </Dialog>
  );
}
